export default "__VITE_ASSET__DtMMGdHi__"